import { render } from "./Drawing.vue?vue&type=template&id=a515e020&scoped=true&ts=true"
import script from "./Drawing.ts?vue&type=script&lang=ts&external"
export * from "./Drawing.ts?vue&type=script&lang=ts&external"

import "./Drawing.vue?vue&type=style&index=0&id=a515e020&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a515e020"]])

export default __exports__